module.exports = __webpack_public_path__ + "img/icon_radio@2x.1db16fe8.png";